export const getChannelIcon = (channelKey: string): string => {
    switch ((channelKey || "").trim().toUpperCase()) {
        case "SMS": return "fa-solid fa-message";
        case "WHATSAPP": return "fa-brands fa-whatsapp";
        case "FACEBOOK": return "fa-brands fa-facebook";
        case "INSTAGRAM": return "fa-brands fa-instagram";
        case "LINE": return "fa-brands fa-line";
        case "SLACK": return "fa-brands fa-slack";
        case "TELEGRAM": return "fa-brands fa-telegram";
        case "GOOGLE_CHAT": return "fa-solid fa-comments";
        case "LAZADA": return "fa-solid fa-shopping-cart";
        case "TIKTOK": return "fa-brands fa-tiktok";
        case "WEB": return "bi bi-display";
        default: return "fa-solid fa-message";
    }
};

export const getChannelColor = (channelKey: string): string => {
    switch ((channelKey || "").trim().toUpperCase()) {
        case "SMS": return "#4caf50";
        case "WHATSAPP": return "#25D366";
        case "FACEBOOK": return "#1877F2";
        case "INSTAGRAM": return "#E4405F";
        case "LINE": return "#00B900";
        case "SLACK": return "#4A154B";
        case "TELEGRAM": return "#2AABEE";
        case "GOOGLE_CHAT": return "#34a853";
        case "LAZADA": return "#f36f21";
        case "TIKTOK": return "#000000";
        case "WEB": return "#AE1536";
        default: return "#824eeb";
    }
};

export const getChannelColorAlpha = (channelKey: string, alpha = 0.4): string => {
    switch ((channelKey || "").trim().toUpperCase()) {
        case "SMS": return `rgba(76,175,80,${alpha})`;
        case "WHATSAPP": return `rgba(37,211,102,${alpha})`;
        case "FACEBOOK": return `rgba(24,119,242,${alpha})`;
        case "INSTAGRAM": return `rgba(228,64,95,${alpha})`;
        case "LINE": return `rgba(0,185,0,${alpha})`;
        case "SLACK": return `rgba(74,21,75,${alpha})`;
        case "TELEGRAM": return `rgba(42,171,238,${alpha})`;
        case "GOOGLE_CHAT": return `rgba(52,168,83,${alpha})`;
        case "LAZADA": return `rgba(243,111,33,${alpha})`;
        case "TIKTOK": return `rgba(0,0,0,${alpha})`;
        case "WEB": return `rgba(174,21,54,${alpha})`;
        default: return `rgba(130,78,235,${alpha})`;
    }
};
